import React from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { locationTableWrapperSx } from './FeeProviderLocationTable.styles';

const LocationTableWrapper = ({ children }) => <Box sx={locationTableWrapperSx}>{children}</Box>;

LocationTableWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LocationTableWrapper;
